<template>
  <div class="nuttrema-change-theme">
     <el-dropdown :size="size" :placement="placement">
      <span class="el-dropdown-link">
        {{ $t('label.change_theme') }} <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
           v-for="theme in themes"
          :class="{ 'is-active': current === theme.code }"
          :key="theme.id">
          <a @click="changeTheme(theme.code)">{{ $t(theme.name) }}</a>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
// import { find, get } from 'lodash';
import { ThemeManager } from 'services';

export default {
  name: 'nuttrema-change-theme',
  props: {
    placement: {
      required: false,
      default: 'bottom-end',
    },
    size: {
      required: false,
      default: 'mini',
    },
  },
  data() {
    return {
      current: null,
      themes: null,
    };
  },
  methods: {
    changeTheme(code) {
      console.log('changeTheme', code);
      this.current = code;
      ThemeManager.changeTheme(code);
    },
  },
  created() {
    this.themes = ThemeManager.listThemes();
    this.current = ThemeManager.getCurrentTheme();
  },
};
</script>

<style lang="scss" scoped>
  .nuttrema-change-theme {
    margin-right: 0.5em;

    &:hover, &:focus, &:active {
      cursor: pointer;
    }

    /deep/ .el-dropdown-link {
      font-weight: 400;
      font-size: 0.9rem;
      > i {
        font-weight: 600;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/button/nuttrema-change-theme.vue